import { useState } from "react";
import { Container } from "../Container/container";
import styles from "./signUpModal.css";

export const Sign = ({ onSignUp }) => {
  const [username, setUsername] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");

  const handleSubmit = (e) => {
  e.preventDefault();
  if (username && email && password.length >= 6) {
    onSignUp(username, email, password);
  } else {
    alert("Please fill all fields correctly");
  }
};

  return (
    <section className="sign">
      <Container>
        <div className="sign__box">
          <h2 className="sign__title">Sign up</h2>
          <form className="sign__form" onSubmit={handleSubmit}>
            <div className="sign__block">
              <label className="sign__label" htmlFor="username">Username</label>
              <input
                className="sign__input"
                type="text"
                id="username"
                name="username"
                required
                value={username}
                onChange={(e) => setUsername(e.target.value)}
              />
            </div>

            <div className="sign__block">
              <label className="sign__label" htmlFor="email">Email:</label>
              <input
                className="sign__input"
                type="email"
                id="email"
                name="email"
                required
                value={email}
                onChange={(e) => setEmail(e.target.value)}
              />
            </div>

            <div className="sign__block">
              <label className="sign__label" htmlFor="password">Password:</label>
              <input
                className="sign__input"
                type="password"
                id="password"
                name="password"
                minLength="6"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
              />
            </div>

            <button className="sign__button" type="submit">Sign up</button>
          </form>
          <p className="sign__desc">
            Already have an account? <span className="sign__span">Log In</span>
          </p>
        </div>
      </Container>
    </section>
  );
};